/**
 * Layer Renderer Factory — Creates the appropriate renderer for a layer type.
 */

import { LayerType } from '../types';
import { LayerRenderer } from './LayerRenderer';
import { SolidBackgroundRenderer } from './SolidBackgroundRenderer';
import { GradientBackgroundRenderer } from './GradientBackgroundRenderer';
import { FrequencyBarsRenderer } from './FrequencyBarsRenderer';
import { MirroredBarsRenderer } from './MirroredBarsRenderer';
import { CircularBarsRenderer } from './CircularBarsRenderer';
import { WaveformRenderer } from './WaveformRenderer';
import { ParticlesRenderer } from './ParticlesRenderer';
import { StarfieldRenderer } from './StarfieldRenderer';
import { GlowOrbRenderer } from './GlowOrbRenderer';
import { RingPulseRenderer } from './RingPulseRenderer';
import { VignetteRenderer } from './VignetteRenderer';

const RENDERER_MAP: Record<LayerType, () => LayerRenderer> = {
  'solid-background': () => new SolidBackgroundRenderer(),
  'gradient-background': () => new GradientBackgroundRenderer(),
  'frequency-bars': () => new FrequencyBarsRenderer(),
  'mirrored-bars': () => new MirroredBarsRenderer(),
  'circular-bars': () => new CircularBarsRenderer(),
  'waveform': () => new WaveformRenderer(),
  'particles': () => new ParticlesRenderer(),
  'starfield': () => new StarfieldRenderer(),
  'glow-orb': () => new GlowOrbRenderer(),
  'ring-pulse': () => new RingPulseRenderer(),
  'vignette': () => new VignetteRenderer(),
};

/** Create a fresh layer renderer for the given layer type */
export function createLayerRenderer(type: LayerType): LayerRenderer {
  const factory = RENDERER_MAP[type];
  if (!factory) throw new Error(`Unknown layer type: ${type}`);
  return factory();
}
